<template>
    <div
        v-if="items"
        class="taxonomyList"
    >
        <ul class="listLevel list-reset">
            <ListItem
                v-for="item in items"
                :key="item.id"
                :item="item"
                :actives="actives"
                @toggleItem="toggleItem"
            />
        </ul>
    </div>
</template>

<script>
import ListItem from './ListItem.vue';
import { get } from '../../utils/apiHelper';

export default {
    components: {
        ListItem,
    },
    props: {
        endpoint: {
            type: String,
            required: true,
        },
        initialActive: {
            type: Array,
            required: true,
        },
    },
    data: () => ({
        items: null,
        actives: [],
    }),
    async created() {
        this.items = await get(this.endpoint);
        this.actives = this.initialActive;
    },
    methods: {
        toggleItem(item) {
            if (this.actives.includes(item.id)) {
                this.removeItem(item);
            } else {
                this.actives.push(item.id);
            }

            this.$emit('changed', this.actives);
        },
        removeItem(item) {
            const index = this.actives.indexOf(item.id);
            if (index !== -1) {
                this.actives.splice(index, 1);
                if (item.children) {
                    this.removeChilds(item.children);
                }
            }
        },
        removeChilds(children) {
            for (let i = 0; i < children.length; i++) {
                this.removeItem(children[i]);
            }
        },
    },
};
</script>

<style lang="postcss" scoped>
</style>
